const HttpMethods = {
  GET: "GET",
  PATCH: "PATCH",
  POST: "POST",
  DELETE: "DELETE",
  PUT: "PUT"
};

export default HttpMethods;
